import { Component, Inject } from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { SubstitutionParameterOptionsInterface } from '@vendasta/templates';
import { VariableMenuItem } from '../variable-menu.service';
import { VariableMenuDialogComponent } from './variable-menu-dialog.component';

interface DialogData {
  includeHtml: boolean;
  partnerId: string;
  marketId: string;
  isOrderAutomation: boolean; // deprecated: should use `supportedSubstitutionOptions` instead
  extraMenuItems: VariableMenuItem[];
  supportedSubstitutionOptions: SubstitutionParameterOptionsInterface;
  dontIncludeDefaultCategories: boolean;
}

@Component({
  imports: [VariableMenuDialogComponent, MatDialogModule, TranslateModule],
  template: `
    <h2 mat-dialog-title>{{ 'HTML_EDITOR.DYNAMIC_CONTENT.ADD_DYNAMIC_CONTENT' | translate }}</h2>
    <div class="form-container">
      <app-variable-menu-dialog
        emitEventsInsteadOfTakingAction="true"
        (formResult)="formResult($event)"
        [partnerId]="partnerId"
        [marketId]="marketId"
        [isOrderAutomation]="isOrderAutomation"
        [extraMenuItems]="extraMenuItems"
        [supportedSubstitutionOptions]="supportedSubstitutionOptions"
        [dontIncludeDefaultCategories]="dontIncludeDefaultCategories"
      ></app-variable-menu-dialog>
    </div>
  `,
  styles: [
    `
      .form-container {
        position: relative;
        height: calc(100% - 69px);
        width: 100%;
      }
    `,
  ],
})
export class VariableMenuMatDialogComponent {
  partnerId: string;
  marketId: string;
  automationId: string;
  isOrderAutomation: boolean;
  extraMenuItems: VariableMenuItem[];
  supportedSubstitutionOptions: SubstitutionParameterOptionsInterface;
  dontIncludeDefaultCategories: boolean;

  constructor(
    public dialogRef: MatDialogRef<VariableMenuMatDialogComponent, string | null>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    this.partnerId = data.partnerId;
    this.marketId = data.marketId;
    this.isOrderAutomation = data.isOrderAutomation;
    this.extraMenuItems = data.extraMenuItems;
    this.supportedSubstitutionOptions = data.supportedSubstitutionOptions;
    this.dontIncludeDefaultCategories = data.dontIncludeDefaultCategories;
  }

  formResult(result: string | null): void {
    this.dialogRef.close(result);
  }
}
